/* featureTypeThunk.ts */

/* Redux Toolkit  */
import { createAsyncThunk } from "@reduxjs/toolkit";

/* Axios */
import axiosInterceptor from "src/utils/helper/axios-interceptor";

/* Utils */
import { transformFeatureTypes } from "src/redux/thunks/custom-cohorts/helper";

/* Interfaces */
import { BasicProps } from "src/shared/interfaces/custom-cohorts/CustomCohorts";
import { FeatureTypesResponse } from "src/shared/interfaces/api/FeatureTypes";

export const fetchFeatureTypes = createAsyncThunk<
  BasicProps[] | undefined,
  string
>("fetchFeatureTypes", async (params: string) => {
  try {
    const response =
      await axiosInterceptor.get<FeatureTypesResponse>(
        "/options/features/types",
        {
          params: {
            main_condition: params,
          },
        }
      );
    const data = transformFeatureTypes(response.data);
    return data;
  } catch (error) {
    console.error(error);
  }
});
